{
  "title": "Einstellungen",
  "tabs": {
    "provider": "Anbieter",
    "connection": "Verbinden",
    "appearance": "Aussehen",
    "agent": "Agent",
    "features": "Features",
    "mcp": "MCP"
  },
  "appearance": {
    "themeHeading": "Design",
    "themeLight": "Hell",
    "themeDark": "Dunkel",
    "themeSystem": "System",
    "themeSystemHint": "System folgt deiner Hell-/Dunkel-Einstellung auf Betriebssystemebene.",
    "preferencesHeading": "Einstellungen",
    "compactDensity": "Kompakte Dichte",
    "compactDensityHint": "Engerer Abstand im gesamten Chat.",
    "soundOnComplete": "Ton bei Fertigstellung",
    "soundOnCompleteHint": "Spielt einen sanften Ton, wenn ein Durchlauf abgeschlossen ist.",
    "titleAnimation": "Titelanimation",
    "titleAnimationHint": "Animierten Terminal-Titel im CLI anzeigen.",
    "languageHeading": "Sprache",
    "languageLabel": "Oberflächensprache",
    "languageHint": "Ändert nur den Oberflächentext. Prompts, Skills und Modellausgaben bleiben unberührt."
  },
  "model": {
    "heading": "Modell",
    "loading": "Modelle werden geladen...",
    "notFound": "Keine Modelle für diesen Anbieter gefunden. Der Katalog könnte leer sein oder noch laden.",
    "selectProviderFirst": "Zuerst einen Anbieter wählen",
    "context": "{{count}}k Kontext"
  },
  "connection": {
    "wsUrlLabel": "WebSocket-Server-URL",
    "wsUrlPlaceholder": "ws://localhost:3457",
    "wsUrlHint": "URL des Agent-WebSocket-Servers. Der Server läuft neben dem CLI.",
    "startingHeading": "Den WebSocket-Server starten",
    "startingBody": "Eigenständig: ./dev.ps1 vom Repo-Root ausführen, oder WS_HOST/WS_PORT vor dem Start von wstackui setzen. Oder alongside der CLI: wstack --webui."
  },
  "provider": {
    "subscriptionHeading": "Abonnement-Anmeldung",
    "apiKeysHeading": "API-Schlüssel-Anbieter",
    "apiKeysBody": "Wähle einen Anbieter aus dem Katalog und füge einen API-Schlüssel hinzu oder verwalte gespeicherte Anbieter.",
    "tabCatalog": "Katalog",
    "tabSaved": "Gespeichert ({{count}})",
    "searchPlaceholder": "{{count}} Anbieter durchsuchen (Name / ID / Familie)…",
    "loadingCatalog": "Katalog wird geladen...",
    "noMatch": "Keine Anbieter passen zu „{{query}}“.",
    "configured": "Konfiguriert",
    "reachable": "Erreichbar",
    "envVar": "ENV: {{var}}",
    "modelCount_one": "{{count}} Modell",
    "modelCount_other": "{{count}} Modelle",
    "keyPlaceholder": "{{name}} API-Schlüssel",
    "orEnv": "Oder stattdessen {{env}} in der Umgebung setzen.",
    "addApiKey": "API-Schlüssel hinzufügen",
    "manageKeys": "Verwalte deine API-Schlüssel und Anbieterkonfigurationen",
    "addProvider": "Anbieter hinzufügen",
    "addCustomHeading": "Benutzerdefinierten Anbieter hinzufügen",
    "localServers": "Lokale Server — zum Ausfüllen klicken:",
    "providerIdPlaceholder": "Anbieter-ID (z.B. my-llm-server)",
    "apiKeyOptionalPlaceholder": "API-Schlüssel (optional)",
    "noSaved": "Noch keine gespeicherten Anbieter",
    "noSavedHint": "Füge einen Anbieter hinzu, um loszulegen",
    "apiKeysLabel": "API-Schlüssel",
    "addKey": "Schlüssel hinzufügen",
    "noKeys": "Keine Schlüssel konfiguriert",
    "active": "Aktiv",
    "setActive": "Als aktiv setzen",
    "keyLabelPlaceholder": "Schlüsselbezeichnung (z.B. default, production)",
    "apiKeyPlaceholder": "API-Schlüssel",
    "saveKey": "Schlüssel speichern",
    "savedToast": "Schlüssel für {{name}} gespeichert"
  },
  "mcp": {
    "status": {
      "connected": "Verbunden",
      "connecting": "Verbinden",
      "sleeping": "Ruhend",
      "discovering": "Entdecken",
      "error": "Fehler",
      "stopped": "Gestoppt",
      "unknown": "Unbekannt"
    },
    "disabled": "MCP-Server sind deaktiviert.",
    "wakeTitle": "Server wecken",
    "sleepTitle": "Server schlafen legen",
    "discoverTitle": "Tools entdecken",
    "editTitle": "Bearbeiten",
    "removeTitle": "Entfernen",
    "statusLabel": "Status:",
    "enabledLabel": "Aktiviert:",
    "yes": "Ja",
    "no": "Nein",
    "descriptionLabel": "Beschreibung:",
    "pidLabel": "PID:",
    "errorLabel": "Fehler:",
    "toolsLabel": "Tools ({{count}}):",
    "noTools": "Noch keine Tools entdeckt",
    "serverNameRequired": "Servername ist erforderlich",
    "dialogTitleEdit": "MCP-Server bearbeiten",
    "dialogTitleAdd": "MCP-Server hinzufügen",
    "dialogTitleAddCustom": "Benutzerdefinierten MCP-Server hinzufügen",
    "fieldName": "Name",
    "fieldNamePlaceholder": "z.B. github, filesystem",
    "fieldTransport": "Transport",
    "fieldUrl": "URL",
    "fieldCommand": "Befehl",
    "fieldCommandPlaceholder": "z.B. npx",
    "fieldArgs": "Args",
    "fieldArgsHint": "(leerzeichengetrennt)",
    "fieldArgsPlaceholder": "z.B. -y @modelcontextprotocol/server-github",
    "fieldEnv": "Env-Variablen",
    "fieldEnvHint": "(KEY=Wert, eine pro Zeile)",
    "fieldDescription": "Beschreibung",
    "fieldDescriptionPlaceholder": "GitHub-MCP-Server für Repository-Zugriff",
    "enableServer": "Server aktivieren",
    "lazyConnect": "Verzögert verbinden",
    "lazyConnectHint": "(erst beim ersten Tool-Aufruf starten; bei Inaktivität automatisch schlafen)",
    "saveChanges": "Änderungen speichern",
    "addServer": "Server hinzufügen",
    "requires": "Erfordert: {{vars}}",
    "added": "Hinzugefügt",
    "heading": "MCP-Server",
    "summary": "{{connected}} verbunden · {{sleeping}} ruhend · {{total}} gesamt",
    "addCustom": "Benutzerdefiniert",
    "tabRecommended": "Empfohlen",
    "tabServers": "Server",
    "tabAddCustom": "Benutzerdefiniert",
    "recommendedBody": "One-Click-Hinzufügen für beliebte MCP-Server. Klicke auf Hinzufügen, um die Konfiguration vorzuausfüllen, und bestätige dann. Server mit Anmeldeinformationen benötigen ihre Env-Variablen vor der Nutzung.",
    "loadingServers": "Server werden geladen...",
    "noServers": "Keine MCP-Server konfiguriert",
    "noServersHint": "Wechsle zum Tab Empfohlen, um beliebte Server hinzuzufügen, oder Benutzerdefiniert für eigene.",
    "addCustomBody": "Konfiguriere einen benutzerdefinierten MCP-Server mit stdio-, SSE- oder HTTP-Transport.",
    "addCustomBodyHint": "Für beliebte Server nutze stattdessen den Tab Empfohlen — alles ist vorkonfiguriert.",
    "removeConfirmTitle": "Server „{{name}}“ entfernen?",
    "removeConfirmBody": "Dies entfernt den MCP-Server aus deiner Konfiguration.",
    "toastAdded": "Server „{{name}}“ hinzugefügt",
    "toastRemoved": "Server „{{name}}“ entfernt",
    "toastDiscovered": "{{count}} Tools von „{{name}}“ entdeckt",
    "toastSleeping": "Server „{{name}}“ ruht jetzt",
    "toastConnected": "Server „{{name}}“ verbunden",
    "toastReconnected": "Server „{{name}}“ neu verbunden",
    "toastDisconnected": "Server „{{name}}“ getrennt: {{reason}}",
    "toastError": "Server „{{name}}“ Fehler: {{error}}",
    "disabledHint": "Aktivieren Sie das \"MCP-Server\"-Feature-Flag im Features-Tab, um diesen Bereich zu nutzen."
  },
  "allowlist": {
    "title": "Gespeicherte Allowlist löschen?",
    "body_one": "Dies entfernt das angeheftete Modell für {{provider}}. Die Modellauswahl fällt auf den models.dev-Katalog zurück.",
    "body_other": "Dies entfernt die {{count}} angehefteten Modelle für {{provider}}. Die Modellauswahl fällt auf den models.dev-Katalog zurück.",
    "undoHint": "Sie können dies 8 Sekunden nach dem Bestätigen rückgängig machen.",
    "keepTitle": "Allowlist behalten (Esc)",
    "clearTitle": "Allowlist löschen (Enter)",
    "clear": "Allowlist löschen"
  },
  "oauth": {
    "termsWarning": "Mit einem Abonnement statt einem API-Schlüssel anmelden. Ein Abonnement außerhalb seines offiziellen Clients zu nutzen, kann die Nutzungsbedingungen des Anbieters verletzen — Ihr Konto könnte ratenlimitiert oder gesperrt werden. Ein API-Schlüssel ist der sanktionierte Weg für programmatische Nutzung.",
    "signIn": "Anmelden",
    "waitingBrowser": "Warte auf Ihre Anmeldung…",
    "openSignIn": "Anmeldeseite öffnen",
    "pasteLoopbackBusy": "Loopback-Port belegt — Redirect-URL einfügen",
    "pasteCantReach": "Browser erreicht diesen Server nicht? Redirect-URL einfügen",
    "submit": "Absenden",
    "enterCode": "Diesen Code auf der Verifizierungsseite eingeben:",
    "openVerification": "Verifizierungsseite öffnen",
    "waitingCode": "Warte auf Autorisierung…",
    "exchanging": "Tokens werden ausgetauscht…",
    "fetchingModels": "Modelle werden geladen…",
    "signedIn": "Angemeldet.",
    "signedInToast": "Angemeldet — {{provider}}",
    "signInFailed": "Anmeldung fehlgeschlagen"
  },
  "agent": {
    "modelHeading": "Modell",
    "autonomyHeading": "Autonomie & Verhalten",
    "autonomyModeLabel": "Autonomie-Modus",
    "autonomyModeHint": "Wie unabhängig der Agent zwischen Zügen fortfährt.",
    "autonomyModeOff": "Aus — volle manuelle Kontrolle",
    "autonomyModeSuggest": "Vorschlagen — schlägt nächste Schritte vor",
    "autonomyModeAuto": "Auto — kurze Bestätigungsverzögerung",
    "autonomyModeEternal": "Eternal — autonom bis Ziel erreicht",
    "autonomyModeEternalParallel": "Eternal Parallel — Multi-Agent-Flotte",
    "autoProceedDelayLabel": "Auto-Fortsetzen-Verzögerung",
    "autoProceedDelayHint": "Millisekunden bevor der Agent im Auto-Modus fortfährt. 0 = sofort.",
    "yoloLabel": "YOLO-Modus",
    "yoloHint": "Tool-Bestätigungs-Prompts umgehen — der Agent läuft ohne Nachfrage.",
    "refineHeading": "Prompt-Verfeinerung",
    "enableRefineLabel": "Verfeinerung aktivieren",
    "enableRefineHint": "Prompts vor dem Senden umschreiben — klarere Anweisungen, bessere Ergebnisse.",
    "refineDelayLabel": "Verfeinerungs-Verzögerung",
    "refineDelayHint": "Countdown bevor der verfeinerte Prompt automatisch gesendet wird.",
    "refineLanguageLabel": "Verfeinerungs-Sprache",
    "refineLanguageHint": "Ihre Sprache behalten oder für das Modell ins Englische übersetzen.",
    "refineLanguageOriginal": "Original — Sprache behalten",
    "refineLanguageEnglish": "Englisch — ins Englische übersetzen",
    "reasoningHeading": "Reasoning & Cache",
    "reasoningModeLabel": "Reasoning-Modus",
    "reasoningModeHint": "Steuern, wie das Modell Extended Thinking nutzt. Auto = Anbieter-Standard.",
    "reasoningModeAuto": "Auto — Anbieter-Standard",
    "reasoningModeOn": "An — Thinking erzwingen",
    "reasoningModeOff": "Aus — Thinking deaktivieren",
    "reasoningEffortLabel": "Reasoning-Aufwand",
    "reasoningEffortHint": "Wie viel Compute das Modell fürs Denken aufwendet. Nur gesendet, wenn das Modell es unterstützt.",
    "reasoningEffortNone": "Keine",
    "reasoningEffortMinimal": "Minimal",
    "reasoningEffortLow": "Niedrig",
    "reasoningEffortMedium": "Mittel",
    "reasoningEffortHigh": "Hoch",
    "reasoningEffortXhigh": "Sehr hoch",
    "reasoningEffortMax": "Max",
    "preserveThinkingLabel": "Thinking bewahren",
    "preserveThinkingHint": "Reasoning-Blöcke über Züge hinweg für Kontextkontinuität behalten.",
    "cacheTtlLabel": "Cache-TTL",
    "cacheTtlHint": "Prompt-Cache-Time-to-Live. 1h kostet mehr beim Schreiben, spart aber bei wiederholten Lesevorgängen (Anthropic).",
    "cacheTtlDefault": "Standard — Anbieter-Standard",
    "cacheTtl5m": "5 Minuten",
    "cacheTtl1h": "1 Stunde",
    "capsHint": "Verwenden Sie wstack models caps um zu prüfen, was das aktuelle Modell unterstützt. Nicht unterstützte Einstellungen werden pro Anfrage still weggelassen.",
    "fallbackHeading": "Modell-Fallbacks",
    "fallbackBody": "Wenn das aktive Modell rate-limited (429/529), 5xx-Fehler oder hängt — nach eigenen Retries — rotiert der Agent zum nächsten Modell dieser Kette. Auch Standard für SDD-Worker-Subagents.",
    "autoFallbackLabel": "Auto-Fallback",
    "autoFallbackHint": "Wenn die Kette oben leer ist, automatisch von Ihren gespeicherten Anbietern ableiten.",
    "favoritesOnlyLabel": "Nur Favoriten",
    "favoritesOnlyHint": "Wenn Auto-Fallback eine Kette ableitet, auf Ihre Favoriten beschränken.",
    "profilesHeading": "Fallback-Profile",
    "addProfile": "Hinzufügen",
    "noProfiles": "Noch keine benannten Fallback-Profile.",
    "createDefault": "Standard aus aktivem Modell erstellen",
    "useChain": "Kette verwenden",
    "setLeader": "Leader setzen",
    "profileEmpty": "Profil ist leer.",
    "favoritesHeading": "Favoriten-Modelle",
    "favoritesEmpty": "Favoriten werden zuerst angezeigt und können Auto-Fallback einschränken.",
    "routingHeading": "Modell-Routing",
    "routingRouteKey": "Modell-Routen-Schlüssel",
    "routingPhasesGroup": "Phasen",
    "routingRolesGroup": "{{label}} Rollen",
    "routingCustomGroup": "Benutzerdefinierte bestehende Routen",
    "routingTargetPlaceholder": "fallback1, provider/model oder leer",
    "routingSet": "Setzen",
    "routingReasoningModeAria": "Reasoning-Modus neue Route",
    "routingReasoningEffortAria": "Reasoning-Aufwand neue Route",
    "routingReasoningPreserveAria": "Reasoning-Bewahrung neue Route",
    "routingReasoningModeFor": "Reasoning-Modus für {{key}}",
    "routingReasoningEffortFor": "Reasoning-Aufwand für {{key}}",
    "routingReasoningPreserveFor": "Reasoning-Bewahrung für {{key}}",
    "noRoutes": "Noch keine Modell-Routen.",
    "leaderModel": "Leader-Modell",
    "hqHeading": "HQ-Client",
    "hqPublishingLabel": "HQ-Veröffentlichung",
    "hqPublishingHint": "Diese WebUI/Client-Sitzung bei WrongStack HQ veröffentlichen. Gleichmaschinige Clients können lokales HQ-Auth auto-entdecken; Remote-Clients nutzen untenstehende URL/Token.",
    "hqUrlLabel": "HQ-URL",
    "hqUrlHint": "Für Auto-Discovery auf gleicher Maschine leer lassen.",
    "hqTokenLabel": "HQ-Client-Token",
    "executionHeading": "Ausführung",
    "maxIterationsLabel": "Max. Iterationen pro Run",
    "maxIterationsHint": "Feste Obergrenze für LLM-Züge pro agent.run().",
    "autoProceedMaxIterationsLabel": "Auto-Fortsetzen max. Iterationen",
    "autoProceedMaxIterationsHint": "Auto-Fortsetzen nach N Iterationen stoppen. 0 = unbegrenzt.",
    "confirmExitLabel": "Vor Exit bestätigen",
    "confirmExitHint": "Erstes Ctrl+C bricht Arbeit ab, zweites bestätigt Exit.",
    "chimeLabel": "Chime bei Fertigstellung",
    "chimeHint": "Terminal-Glocke, wenn ein Agent-Run endet.",
    "fleetHeading": "Flotte & Streaming",
    "streamFleetLabel": "Flotten-Events streamen",
    "streamFleetHint": "Live-Subagent-Aktivität im Flotten-Panel zeigen.",
    "maxConcurrentLabel": "Max. gleichzeitige Subagents",
    "maxConcurrentHint": "Maximale Anzahl gleichzeitig laufender Subagents.",
    "nextPredictionLabel": "Next-Step-Vorhersage",
    "nextPredictionHint": "Nach Abschluss eines Zugs wahrscheinliche nächste Schritte vorhersagen.",
    "telegramHeading": "Telegram-Benachrichtigungen",
    "telegramSessionEndLabel": "Sitzungsende",
    "telegramSessionEndHint": "Zusammenfassung senden, wenn eine Sitzung endet.",
    "telegramDelegateLabel": "Delegat fertig",
    "telegramDelegateHint": "Vermenschlichte Notiz senden, wenn ein Subagent fertig ist.",
    "telegramLongToolLabel": "Langlaufende Tools",
    "telegramLongToolHint": "Benachrichtigen, wenn ein Tool {{ms}}ms überschreitet. 0 zum Deaktivieren.",
    "telegramChangesApply": "Änderungen werden sofort angewendet.",
    "telegramNotConfigured": "Telegram ist nicht konfiguriert. Führen Sie /telegram-setup in der CLI aus, um zuerst einen Bot zu verbinden.",
    "addModelToProfile": "Modell zum Profil hinzufügen…",
    "addFavoriteModel": "Favoritenmodell hinzufügen…",
    "hqRawContentLabel": "Rohe HQ-Inhalte",
    "hqRawContentHint": "Rohe Inhaltsvorschauen statt geschwärzter Vorschauen an HQ senden."
  },
  "features": {
    "flagsHeading": "Feature-Flags",
    "mcpLabel": "MCP-Server",
    "mcpHint": "Model Context Protocol-Integrationen aktivieren.",
    "pluginsLabel": "Plugins",
    "pluginsHint": "Vom Nutzer installierte Plugins laden und ausführen.",
    "memoryLabel": "Speicher",
    "memoryHint": "Fakten sitzungsübergreifend speichern und abrufen.",
    "skillsLabel": "Skills",
    "skillsHint": "Domänenspezifische Skill-Prompts laden.",
    "modelsRegistryLabel": "Modell-Registry",
    "modelsRegistryHint": "Das models.dev-Katalog zur Anbieter-Entdeckung nutzen.",
    "indexOnStartLabel": "Beim Start indizieren",
    "indexOnStartHint": "Symbol-Index der Codebasis beim Sitzungsstart aufbauen.",
    "contextHeading": "Kontext & Debug",
    "autoCompactLabel": "Kontext auto-kompaktieren",
    "autoCompactHint": "Kontextfenster in der Nähe von Limits automatisch kürzen.",
    "compactorStrategyLabel": "Compaktor-Strategie",
    "compactorStrategyHint": "Wie der Kontext komprimiert wird, wenn er zu groß wird.",
    "compactorStrategyHybrid": "Hybrid — schnelle Regeln (Standard)",
    "compactorStrategyIntelligent": "Intelligent — LLM-Zusammenfassung",
    "compactorStrategySelective": "Selektiv — LLM-gesteuerte Auswahl",
    "contextModeLabel": "Kontext-Modus",
    "contextModeHint": "Kontextfenster-Richtlinie — balanced ist Standard.",
    "contextModeBalanced": "Ausgewogen — normale Kontextnutzung",
    "contextModeFrugal": "Sparsam — konservative Token-Nutzung",
    "contextModeDeep": "Tief — größerer Kontext für komplexe Aufgaben",
    "contextModeArchival": "Archiv — Kontextbindung maximieren",
    "tokenSavingLabel": "Token-Sparmodus",
    "tokenSavingHint": "Wie aggressiv die Token-Nutzung reduziert wird.",
    "tokenSavingOff": "Aus — kein Token-Sparen",
    "tokenSavingMinimal": "Minimal — grundlegende Optimierung",
    "tokenSavingLight": "Leicht — moderate Reduktion",
    "tokenSavingMedium": "Mittel — erhebliche Einsparungen",
    "tokenSavingAggressive": "Aggressiv — maximale Komprimierung",
    "logLevelLabel": "Log-Level",
    "logLevelHint": "Mindest-Schweregrad für serverseitiges Logging.",
    "logLevelDebug": "Debug — alles",
    "logLevelInfo": "Info — normaler Ablauf",
    "logLevelWarn": "Warn — nur Probleme",
    "logLevelError": "Error — nur Fehler",
    "auditLevelLabel": "Audit-Level",
    "auditLevelHint": "Detaillierungsgrad für Sitzungs-Audit-Logs.",
    "auditLevelMinimal": "Minimal — nur Fehler",
    "auditLevelStandard": "Standard — Tool-Aufrufe + Fehler",
    "auditLevelFull": "Voll — jedes Ereignis (große Logs)"
  },
  "toast": {
    "switchingTo": "Wechseln zu {{provider}} / {{model}}…",
    "fallbackExists": "Fallback-Profil \"{{name}}\" existiert bereits",
    "selectProviderModelFirst": "Wählen Sie zuerst einen Anbieter und ein Modell",
    "defaultProfileCreated": "Standard-Fallback-Profil erstellt",
    "profileEmpty": "Fallback-Profil \"{{name}}\" ist leer",
    "leaderSetFrom": "Leader aus {{name}} gesetzt"
  }
}
